/**
 * Reduces multiple calls to a function to only one call every set interval
 * @param  {Function} fn [The function to throttle]
 * @param  {[number]} delay [The timeframe interval in miliseconds]
 */
const throttle = <T extends (...args: unknown[]) => void>(fn: T, timeframeInMilisecond: number): T => {
    let lastTimestamp = 0;
    let count = 0; // count all messages in the given timeframe

    return ((...args: Parameters<T>) => {
        const now = Date.now();
        count += 1;
        if (now - lastTimestamp >= timeframeInMilisecond) {
            fn(...args, count);
            lastTimestamp = now;
            count = 0;
        }
    }) as T;
};

export default throttle;
